// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"currentColor","d":"M19.5 7.57a3 3 0 110 6H16v1.46a3 3 0 01-.4 1.51l-2.42 4.13a3 3 0 01-3.54 1.34l-6.09-2.04a3 3 0 01-2.05-2.84V9.06a3 3 0 011.17-2.38l6.29-4.84 1.52 1.02a2 2 0 01.85 2.1l-.58 2.61h8.75zm1 3a1 1 0 00-1-1H8.25l1.13-5.05-.34-.22L3.9 8.26a1 1 0 00-.39.8v8.07a1 1 0 00.68.95l6.1 2.03a1 1 0 001.17-.45l2.41-4.13a1 1 0 00.14-.5v-3.46h5.5a1 1 0 001-1z"}}]};

const GestureRightIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'gesture-right',
    ref,
    icon: element,
  },
));

GestureRightIcon.displayName = 'GestureRightIcon';

export default GestureRightIcon;
